/* import __COLOCATED_TEMPLATE__ from './dummy-container.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();